"use strict";
exports.__esModule = true;
var PHPModule = /** @class */ (function () {
    function PHPModule(phpClient) {
        this.phpClient = phpClient;
    }
    PHPModule.prototype.login = function (username, password) {
        return this.phpClient.login(username, password);
    };
    /**
     * 查询城市、热点、门店
     */
    PHPModule.prototype.querySelectList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.querySelectList(data);
    };
    /**
     * 查询订单来源
     */
    PHPModule.prototype.queryOrderSource = function () {
        return this.phpClient.orderSource();
    };
    /**
     * 查询订单来源列表
     * @param page
     * @param rows
     * @param filter
     * @param sort
     * @param asc
     */
    PHPModule.prototype.orderSourceList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.orderSourceList(data);
    };
    /**
     * 新增订单来源
     * @param name
     * @param sourceType
     * @param isShow
     * @param status
     * @param remark
     * @param needShortGuarentee
     * @param tip
     * @param invoceConfig
     * @param expression
     */
    PHPModule.prototype.addOrderSource = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addOrderSource(data);
    };
    /**
     * 编辑订单来源
     * @param id
     * @param name
     * @param sourceType
     * @param isShow
     * @param status
     * @param remark
     * @param needShortGuarentee
     * @param tip
     * @param invoceConfig
     * @param expression
     */
    PHPModule.prototype.editOrderSource = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editOrderSource(data);
    };
    /**
     * 查询订单列表
     * @param page
     * @param size
     * @param orderNo
     * @param phone
     * @param roomNo
     * @param stat
     * @param sourceType
     * @param payStat
     * @param checkin
     * @param city
     * @param hotspotName
     * @param chainName
     * @param rentType
     * @param orderName
     * @param otherNo
     * @param startDate
     * @param endDate
     */
    PHPModule.prototype.queryOrderDataByDateExt = function (params) {
        return this.phpClient.queryOrderDataByDateExt(params);
    };
    /**
     * 查询订单开票管理列表
     * @param finishTimeStart
     * @param finishTimeEnd
     * @param page
     * @param size
     * @param orderNo
     * @param source
     * @param invoiceType
     * @param namePhone
     * @param issueBeginDate
     * @param issueEndDate
     */
    PHPModule.prototype.queryInvoiceManageByDate = function (params) {
        return this.phpClient.queryInvoiceManageByDate(params);
    };
    /**
     * 导出订单开票列表数据
     * @param page
     * @param size
     */
    PHPModule.prototype.queryInvoiceManageByDateExcelData = function (params) {
        return this.phpClient.queryInvoiceManageByDateExcelData(params);
    };
    /**
     * 订单管理客服开票
     *
     */
    PHPModule.prototype.signInvoice = function (params) {
        return this.phpClient.signInvoice(params);
    };
    /**
     * 订单添加备注
     * @param orderNo 订单号
     * @param remark 备注内容
     */
    PHPModule.prototype.addRemark = function (orderNo, remark) {
        return this.phpClient.addRemark(orderNo, remark);
    };
    /**
     * 查询退款单列表
     * @param startDate
     * @param endDate
     * @param page
     * @param size
     * @param orderNo
     * @param refundStat
     * @param refundType
     * @param refundRea
     * @param refundWay
     */
    PHPModule.prototype.refundsList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.refundsList(data);
    };
    /**
     * 新建退款单
     * @param orderNo
     * @param refundType
     * @param price
     * @param reason
     * @param createType
     * @param priceInt
     */
    PHPModule.prototype.createRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.createRefund(data);
    };
    /**
     * 取消退款单
     * @param id
     * @param sourceId
     * @param remark
     */
    PHPModule.prototype.cancelRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.cancelRefund(data);
    };
    /**
     * 手动退款
     * @param id
     * @param sourceId
     * @param payType
     * @param stat
     * @param activeMoney
     * @param refundChannel
     * @param receiveSource
     * @param aliPay
     * @param bankName
     * @param bankCount
     * @param remark
     * @param receiveAccount
     * @param refundAmout
     * @param changeMoney
     * @param tip
     * @param activeMoneyInt
     * @param refundAmoutInt
     */
    PHPModule.prototype.confirmRefund = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.confirmRefund(data);
    };
    /**
     * 查询自用单列表
     * @param beginDate
     * @param endDate
     * @param page
     * @param rows
     */
    PHPModule.prototype.queryOwnerOrderList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryOwnerOrderList(data);
    };
    //////////////////////////// 订单详情相关接口 ////////////////////////////////
    /**
     * 根据xbed订单号查询订单数量
     * @param xbedOrderNo
     */
    PHPModule.prototype.queryOrderCountByXbedOrderNo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryOrderCountByXbedOrderNo(data);
    };
    /**
     * 获取权限信息
     * @param menuId
     */
    PHPModule.prototype.getOrderPower = function (menuId) {
        return this.phpClient.getOrderPower(menuId);
    };
    /**
     * 获取入住信息
     * @param checkinId
     */
    PHPModule.prototype.getcheckInfo = function (checkinId) {
        return this.phpClient.getcheckInfo(checkinId);
    };
    /**
     * 获取子订单信息
     * @param orderNo
     */
    PHPModule.prototype.getSettlement = function (orderNo) {
        return this.phpClient.getSettlement(orderNo);
    };
    /**
     * 根据订单号获取订单信息
     * @param orderNo
     */
    PHPModule.prototype.getOrder = function (orderNo) {
        return this.phpClient.getOrder(orderNo);
    };
    /**
     * 根据订单号获取支付信息
     * @param orderNo
     */
    PHPModule.prototype.payInfo = function (orderNo) {
        return this.phpClient.payInfo(orderNo);
    };
    /**
     * 根据订单号获取订单操作记录
     * @param orderNo
     */
    PHPModule.prototype.getOrderTrail = function (orderNo) {
        return this.phpClient.getOrderTrail(orderNo);
    };
    /**
     * 获取退款明细列表
     * @param orderNo
     */
    PHPModule.prototype.queryRefunds = function (orderNo) {
        return this.phpClient.queryRefunds(orderNo);
    };
    /**
     * 代客支付
     * @param data
     */
    PHPModule.prototype.payCheckin = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.payCheckin(data);
    };
    /**
     * 添加入住人
     * @param checkinId
     * @param userName
     * @param phone
     */
    PHPModule.prototype.addCustomer = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addCustomer(data);
    };
    /**
     * 办理入住
     * @param checkinId
     * @param infoId
     */
    PHPModule.prototype.checkin = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.checkin(data);
    };
    /**
     * 删除入住人
     * @param id
     */
    PHPModule.prototype.delCustomer = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.delCustomer(data);
    };
    /**
     * 取消子入住单
     * @param infoId
     */
    PHPModule.prototype.cancleChildOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.cancleChildOrder(data);
    };
    /**
     * 取消入住单
     * @param checkinId
     * @param remark
     */
    PHPModule.prototype.cancleOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.cancleOrder(data);
    };
    /**
     * 查询门店
     * @param beginDate
     * @param endDate
     * @param roomId
     * @param checkinId
     */
    PHPModule.prototype.onQueryHotelList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.onQueryHotelList(data);
    };
    /**
     * 查询房型
     * @param operTypeList  //"operTypeList":["roomType"]
     */
    PHPModule.prototype.onQueryRoomType = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.onQueryRoomType(data);
    };
    /**
     * 查询房间列表
     * @param beginDate
     * @param endDate
     * @param chainId
     * @param roomTypeName
     * @param custRoomNo
     * @param custRoomName
     * @param roomID
     * @param rentType  // 'cnameWay=租赁方式/短租'
     */
    PHPModule.prototype.onQureyRoomList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.onQureyRoomList(data);
    };
    /**
     * 更换房间
     * @param roomId,
     * @param checkinId,
     * @param needPayBanlance
     * @param remark
     */
    PHPModule.prototype.changeRoomId = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.changeRoomId(data);
    };
    /**
     * 差价接口
     * @param data
     */
    PHPModule.prototype.queryDiffPrice = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryDiffPrice(data);
    };
    /**
     * 办理续住
     * @param checkinId,
     * @param endDate,
     * @param userId
     * @param rentType
     */
    PHPModule.prototype.overStayCalculation = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.overStayCalculation(data);
    };
    /**
     * 获取续住优惠(长租)
     * @param checkinId,
     * @param endDate,
     * @param userId
     * @param source
     * @param rentType
     */
    PHPModule.prototype.queryOverstayDiscount = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryOverstayDiscount(data);
    };
    /**
     * 提交续住信息
     * @param checkinId,
     * @param endDate,
     * @param userId,
     * @param source,
     * @param rentType,
     * @param price,
     * @param remark,
     */
    PHPModule.prototype.overstayCheckin = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.overstayCheckin(data);
    };
    /**
     * 获取退房押金
     * @param checkinId
     */
    PHPModule.prototype.getCheckOutMoney = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.getCheckOutMoney(data);
    };
    /**
     * 立即退房
     * @param checkinId
     * @param realRefundAmount
     * @param bargainMoney
     * @param remark
     */
    PHPModule.prototype.subCheckoutInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.subCheckoutInfo(data);
    };
    /**
     * 查看入住人详情
     * @param mobile
     * @param lodgerId
     */
    PHPModule.prototype.queryLodgerInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryLodgerInfo(data);
    };
    /**
     * 重置入住单密码
     * @param checkinId
     * @param phone
     */
    PHPModule.prototype.resetPwd = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.resetPwd(data);
    };
    /**
     * 身份验证
     * @param checkinId
     */
    PHPModule.prototype.validateCheckiner = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.validateCheckiner(data);
    };
    //////////////////////////// 订单详情相关接口end ////////////////////////////////
    /**
     * 根据roomType 查询mode style type
     */
    PHPModule.prototype.queryModeAndStyleAndType = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryModeAndStyleAndType(data);
    };
    /**
     * 获取热点权限id
     */
    PHPModule.prototype.getHotSpotIds = function () {
        return this.phpClient.getHotSpotIds();
    };
    /**
     * 代下单——获取优惠类型
     */
    PHPModule.prototype.queryDiscountType = function () {
        return this.phpClient.discountType();
    };
    /**
     * 代下单——查询全部城市
     */
    PHPModule.prototype.queryAllCities = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryAllCities();
    };
    /**
     * 代下单——根据城市和热点ID查询门店
     */
    PHPModule.prototype.queryChainByCity = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryChainByCity(data);
    };
    /**
     * 查看开发队伍
     * @param data
     */
    PHPModule.prototype.getDevelopTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.getDevelopTeam(data);
    };
    /**
     * 修改或新增开发队伍
     * @param data
     */
    PHPModule.prototype.editDeveloperTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editDeveloperTeam(data);
    };
    /**
     * 删除开发队伍
     * @param data
     */
    PHPModule.prototype.delDeveloperTeam = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.delDeveloperTeam(data);
    };
    /**
     * 代下单接口
     * @param data
     */
    PHPModule.prototype.createNewOrder = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.createNewOrder(data);
    };
    /**
     * 蓝主任业主列表
     * @param data
     */
    PHPModule.prototype.hosterList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.hosterList(data);
    };
    /**
     * 修改会员信息
     * @param userId 用户id
     * @param realname 用户名
     * @param email 邮箱
     * @param remark 备注
     */
    PHPModule.prototype.editUser = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editUser(data);
    };
    /**
     * 修改会员状态
     * @param userId 用户id
     * @param userStat 用户状态
     */
    PHPModule.prototype.editUserState = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editUserState(data);
    };
    /**
     * 新增会员
     * @param realname 用户名
     * @param phone 手机号
     * @param sex 性别
     * @param email 邮箱
     * @param mainSource 主渠道
     * @param nodeSource 父渠道(非必填)
     * @param source 子渠道(非必填)
     * @param selectedSource 最后选中的渠道
     * @param remark 备注(非必填)
     */
    PHPModule.prototype.addUser = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addUser(data);
    };
    //////////////////////////// 会员管理 ///////////////////////////
    /**
     * 获取会员基本信息
     * @param userId
     */
    PHPModule.prototype.queryUserById = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryUserById(data);
    };
    /**
     * 获取验证码
     * @param phone
     */
    PHPModule.prototype.userValidCode = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.userValidCode(data);
    };
    /**
     * 获取省份列表
     * @param
     */
    PHPModule.prototype.provincesList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.provincesList(data);
    };
    /**
     * 获取城市列表
     * @param id
     */
    PHPModule.prototype.cityList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.cityList(data);
    };
    /**
     * 获取区列表
     * @param id
     */
    PHPModule.prototype.countyslist = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.countyslist(data);
    };
    /**
     * 修改密码
     * @param lodgerId
     * @param password
     * @param rePwd
     */
    PHPModule.prototype.changePwd = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.changePwd(data);
    };
    /**
     * 修改经验值
     * @param userId
     * @param integral
     * @param remark
     */
    PHPModule.prototype.editIntegral = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editIntegral(data);
    };
    /**
     * 获取会员推广信息
     * @param userId
     */
    PHPModule.prototype.findUserPromoInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.findUserPromoInfo(data);
    };
    /**
     * 获取会员邮寄地址
     * @param userId
     */
    PHPModule.prototype.userPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.userPostAddress(data);
    };
    /**
     * 增加邮寄地址
     * @param userId
     * @param addressId
     * @param realname
     * @param phone
     * @param title
     * @param province
     * @param city
     * @param county
     * @param address
     * @param code
     */
    PHPModule.prototype.addPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addPostAddress(data);
    };
    /**
     * 删除邮寄地址
     * @param addressId
     */
    PHPModule.prototype.delPostAddress = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.delPostAddress(data);
    };
    /**
     * 查询会员管理列表
     * @param page 页数
     * @param rows 每页数据量
     */
    PHPModule.prototype.queryAllUsers = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryAllUsers(data);
    };
    /**
     * 查询用户来源渠道
     */
    PHPModule.prototype.queryUsersSources = function () {
        return this.phpClient.queryUsersSources();
    };
    //////////////////////////// 会员管理end ///////////////////////////
    //////////////////////////// 入账单列表start ///////////////////////////
    /**
     * 取消入账单
     * @param id
     * @param remark
     */
    PHPModule.prototype.cancelConsumption = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.cancelConsumption(data);
    };
    /**
     * 初始化入账单列表
     * @param id
     * @param remark
     */
    PHPModule.prototype.queryConsumptionsByDate = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryConsumptionsByDate(data);
    };
    /**
     * 控制子菜单显示对象
     * @param menuId // 菜单id
     */
    PHPModule.prototype.getPowers = function (menuId) {
        return this.phpClient.getPowers(menuId);
    };
    /**
     * 定义加载预定渠道的方法
     */
    PHPModule.prototype.orderSourceListAll = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.orderSourceListAll(data);
    };
    //////////////////////////// 入账单列表end ///////////////////////////
    /**
     * 查询美团渠道门店/房型列表
     * @param data
     */
    PHPModule.prototype.mtChannelHotelList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.mtChannelHotelList(data);
    };
    /**
     * querySortList
     * 查询房间信息的房间排序
     */
    PHPModule.prototype.querySortList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.querySortList(data);
    };
    /**
     *房间排序 queryRoomTagByCname
     * 获取热门城市
     */
    PHPModule.prototype.queryRoomTagByCname = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryRoomTagByCname(data);
    };
    /**
     * editSort
     * 房间排序： 修改删除房间
     */
    PHPModule.prototype.editSort = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editSort(data);
    };
    /**添加房间
     * addSortByRoomIds
     * roomIds ：array 房间Id
     * sort ：权重
     */
    PHPModule.prototype.addSortByRoomIds = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addSortByRoomIds(data);
    };
    /**
     * queryAllRoom
     * 房间排序查询所有的房间
     */
    PHPModule.prototype.queryAllRoom = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.queryAllRoom(data);
    };
    /**
     * oms-微信获取菜单
     * @param data
     */
    PHPModule.prototype.getMenuList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.getMenuList(data);
    };
    /**
     * oms-微信获取父级菜单
     * @param data
     */
    PHPModule.prototype.parentMenuList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.parentMenuList(data);
    };
    /**
     * oms-微信生成菜单
     * @param data
     */
    PHPModule.prototype.generateMenu = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.generateMenu(data);
    };
    /**
     * oms-微信新增菜单
     * @param data
     */
    PHPModule.prototype.addMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addMenuItem(data);
    };
    /**
     * oms-微信编辑菜单
     * @param data
     */
    PHPModule.prototype.editMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editMenuItem(data);
    };
    /**
     * oms-微信删除菜单
     * @param data
     */
    PHPModule.prototype.delMenuItem = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.delMenuItem(data);
    };
    /**
     * 蓝主人-获取公司信息
     * @param data
     */
    PHPModule.prototype.companyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.companyInfo(data);
    };
    /**
     * 蓝主人-编辑公司信息
     * @param data
     */
    PHPModule.prototype.editCompanyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editCompanyInfo(data);
    };
    /**
     * 蓝主人-添加公司信息
     * @param data
     */
    PHPModule.prototype.addCompanyInfo = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addCompanyInfo(data);
    };
    /**
     * 开发员列表
     * @param data
     */
    PHPModule.prototype.developList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.developList(data);
    };
    /**
     * 蓝主人-添加业主
     * @param data
     */
    PHPModule.prototype.addHoster = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addHoster(data);
    };
    /**
     * 添加门店
     * @param data
     */
    PHPModule.prototype.addChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.addChain(data);
    };
    /**
     * 编辑门店
     * @param data
     */
    PHPModule.prototype.editChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.editChain(data);
    };
    /**
     * 基础数据-根据城市查询商圈
     * @param data
     */
    PHPModule.prototype.tagChildList = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.tagChildList(data);
    };
    /**
     * 删除门店
     * @param data
     */
    PHPModule.prototype.delChain = function (data) {
        if (data === void 0) { data = {}; }
        return this.phpClient.delChain(data);
    };
    return PHPModule;
}());
exports.PHPModule = PHPModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9waHAvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQTtJQUVFLG1CQUFZLFNBQW9CO1FBQzlCLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO0lBQzdCLENBQUM7SUFFTSx5QkFBSyxHQUFaLFVBQWEsUUFBZ0IsRUFBRSxRQUFnQjtRQUM3QyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQ2xELENBQUM7SUFFRDs7T0FFRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRDs7T0FFRztJQUNJLG9DQUFnQixHQUF2QjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBQ3RDLENBQUM7SUFFRDs7Ozs7OztPQU9HO0lBQ0ksbUNBQWUsR0FBdEIsVUFBdUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNuQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVEOzs7Ozs7Ozs7OztPQVdHO0lBQ0ksa0NBQWMsR0FBckIsVUFBc0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNsQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDN0MsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7T0FZRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7OztPQW1CRztJQUNJLDJDQUF1QixHQUE5QixVQUErQixNQXNCOUI7UUFDQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyx1QkFBdUIsQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUN4RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7OztPQVlHO0lBQ0ksNENBQXdCLEdBQS9CLFVBQWdDLE1BVy9CO1FBQ0MsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsd0JBQXdCLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDekQsQ0FBQztJQUNEOzs7O09BSUc7SUFDSSxxREFBaUMsR0FBeEMsVUFBeUMsTUFBZ0M7UUFDdkUsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsaUNBQWlDLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDbEUsQ0FBQztJQUNEOzs7T0FHRztJQUNJLCtCQUFXLEdBQWxCLFVBQW1CLE1BQVU7UUFDM0IsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksNkJBQVMsR0FBaEIsVUFBaUIsT0FBZSxFQUFFLE1BQWM7UUFDOUMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLE9BQU8sRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNuRCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7O09BV0c7SUFDSSwrQkFBVyxHQUFsQixVQUFtQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQy9CLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSxnQ0FBWSxHQUFuQixVQUFvQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxnQ0FBWSxHQUFuQixVQUFvQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7T0FtQkc7SUFDSSxpQ0FBYSxHQUFwQixVQUFxQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2pDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksdUNBQW1CLEdBQTFCLFVBQTJCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDdkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsbUJBQW1CLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDbEQsQ0FBQztJQUVELHNFQUFzRTtJQUV0RTs7O09BR0c7SUFDSSxnREFBNEIsR0FBbkMsVUFBb0MsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNoRCxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyw0QkFBNEIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzRCxDQUFDO0lBQ0Q7OztPQUdHO0lBQ0ksaUNBQWEsR0FBcEIsVUFBcUIsTUFBYztRQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLGdDQUFZLEdBQW5CLFVBQW9CLFNBQWlCO1FBQ25DLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNoRCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksaUNBQWEsR0FBcEIsVUFBcUIsT0FBZTtRQUNsQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDRCQUFRLEdBQWYsVUFBZ0IsT0FBZTtRQUM3QixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDJCQUFPLEdBQWQsVUFBZSxPQUFlO1FBQzVCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksaUNBQWEsR0FBcEIsVUFBcUIsT0FBZTtRQUNsQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVEOzs7T0FHRztJQUNJLGdDQUFZLEdBQW5CLFVBQW9CLE9BQWU7UUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRDs7O09BR0c7SUFDSSw4QkFBVSxHQUFqQixVQUFrQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzlCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSwrQkFBVyxHQUFsQixVQUFtQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQy9CLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDJCQUFPLEdBQWQsVUFBZSxJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzNCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN0QyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLG9DQUFnQixHQUF2QixVQUF3QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3BDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9DLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLG9DQUFnQixHQUF2QixVQUF3QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3BDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9DLENBQUM7SUFFRDs7O09BR0c7SUFDSSxtQ0FBZSxHQUF0QixVQUF1QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ25DLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7T0FVRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRDs7Ozs7O09BTUc7SUFDSSxnQ0FBWSxHQUFuQixVQUFvQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksa0NBQWMsR0FBckIsVUFBc0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNsQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDN0MsQ0FBQztJQUVEOzs7Ozs7T0FNRztJQUNJLHVDQUFtQixHQUExQixVQUEyQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3ZDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLG1CQUFtQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2xELENBQUM7SUFFRDs7Ozs7OztPQU9HO0lBQ0kseUNBQXFCLEdBQTVCLFVBQTZCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDekMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMscUJBQXFCLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDcEQsQ0FBQztJQUVEOzs7Ozs7Ozs7T0FTRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxvQ0FBZ0IsR0FBdkIsVUFBd0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNwQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMvQyxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksbUNBQWUsR0FBdEIsVUFBdUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNuQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxtQ0FBZSxHQUF0QixVQUF1QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ25DLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM5QyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDRCQUFRLEdBQWYsVUFBZ0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUM1QixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLHFDQUFpQixHQUF4QixVQUF5QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3JDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2hELENBQUM7SUFFRCx5RUFBeUU7SUFFekU7O09BRUc7SUFDSSw0Q0FBd0IsR0FBL0IsVUFBZ0MsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUM1QyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyx3QkFBd0IsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2RCxDQUFDO0lBRUQ7O09BRUc7SUFDSSxpQ0FBYSxHQUFwQjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGFBQWEsRUFBRSxDQUFDO0lBQ3hDLENBQUM7SUFFRDs7T0FFRztJQUNJLHFDQUFpQixHQUF4QjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksRUFBRSxDQUFDO0lBQ3ZDLENBQUM7SUFFRDs7T0FFRztJQUNJLGtDQUFjLEdBQXJCLFVBQXNCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxFQUFFLENBQUM7SUFDekMsQ0FBQztJQUVEOztPQUVHO0lBQ0ksb0NBQWdCLEdBQXZCLFVBQXdCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDcEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVEOzs7T0FHRztJQUNJLGtDQUFjLEdBQXJCLFVBQXNCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxxQ0FBaUIsR0FBeEIsVUFBeUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNyQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNoRCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksb0NBQWdCLEdBQXZCLFVBQXdCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDcEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDL0MsQ0FBQztJQUVEOzs7T0FHRztJQUNJLGtDQUFjLEdBQXJCLFVBQXNCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFFRDs7O09BR0c7SUFDSSw4QkFBVSxHQUFqQixVQUFrQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzlCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksNEJBQVEsR0FBZixVQUFnQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzVCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLGlDQUFhLEdBQXBCLFVBQXFCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFFRDs7Ozs7Ozs7Ozs7T0FXRztJQUNJLDJCQUFPLEdBQWQsVUFBZSxJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzNCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN0QyxDQUFDO0lBRUQsNkRBQTZEO0lBQzdEOzs7T0FHRztJQUNJLGlDQUFhLEdBQXBCLFVBQXFCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxpQ0FBYSxHQUFwQixVQUFxQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2pDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksaUNBQWEsR0FBcEIsVUFBcUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDRCQUFRLEdBQWYsVUFBZ0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUM1QixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLCtCQUFXLEdBQWxCLFVBQW1CLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDL0IsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzFDLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLDZCQUFTLEdBQWhCLFVBQWlCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDN0IsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3hDLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLGdDQUFZLEdBQW5CLFVBQW9CLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDaEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzNDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxxQ0FBaUIsR0FBeEIsVUFBeUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNyQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNoRCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksbUNBQWUsR0FBdEIsVUFBdUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNuQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUVEOzs7Ozs7Ozs7Ozs7T0FZRztJQUNJLGtDQUFjLEdBQXJCLFVBQXNCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxrQ0FBYyxHQUFyQixVQUFzQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2xDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM3QyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLGlDQUFhLEdBQXBCLFVBQXFCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFFRDs7T0FFRztJQUNJLHFDQUFpQixHQUF4QjtRQUNFLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGlCQUFpQixFQUFFLENBQUM7SUFDNUMsQ0FBQztJQUNELGdFQUFnRTtJQUVoRSxtRUFBbUU7SUFDbkU7Ozs7T0FJRztJQUNJLHFDQUFpQixHQUF4QixVQUF5QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3JDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2hELENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksMkNBQXVCLEdBQTlCLFVBQStCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDM0MsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsdUJBQXVCLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDZCQUFTLEdBQWhCLFVBQWlCLE1BQWM7UUFDN0IsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzFDLENBQUM7SUFFRDs7T0FFRztJQUNJLHNDQUFrQixHQUF6QixVQUEwQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3RDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGtCQUFrQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2pELENBQUM7SUFDRCxpRUFBaUU7SUFFakU7OztPQUdHO0lBQ0ksc0NBQWtCLEdBQXpCLFVBQTBCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDdEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsa0JBQWtCLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDakQsQ0FBQztJQUNEOzs7T0FHRztJQUNJLGlDQUFhLEdBQXBCLFVBQXFCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDakMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVDLENBQUM7SUFDRDs7O09BR0c7SUFDSSx1Q0FBbUIsR0FBMUIsVUFBMkIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUN2QyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNsRCxDQUFDO0lBQ0Q7OztPQUdHO0lBQ0ksNEJBQVEsR0FBZixVQUFnQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzVCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBQ0Q7Ozs7T0FJRztJQUNJLG9DQUFnQixHQUF2QixVQUF3QixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ3BDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGdCQUFnQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBQy9DLENBQUM7SUFDRDs7O09BR0c7SUFDSSxnQ0FBWSxHQUFuQixVQUFvQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBQ0Q7OztPQUdHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUNEOzs7T0FHRztJQUNJLGtDQUFjLEdBQXJCLFVBQXNCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFDRDs7O09BR0c7SUFDSSxnQ0FBWSxHQUFuQixVQUFvQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2hDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBQ0Q7OztPQUdHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUNEOzs7T0FHRztJQUNJLGdDQUFZLEdBQW5CLFVBQW9CLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDaEMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzNDLENBQUM7SUFDRDs7O09BR0c7SUFDSSwrQkFBVyxHQUFsQixVQUFtQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQy9CLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBQ0Q7OztPQUdHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUNEOzs7T0FHRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDbkMsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzlDLENBQUM7SUFDRDs7O09BR0c7SUFDSSxrQ0FBYyxHQUFyQixVQUFzQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQ2xDLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUM3QyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksK0JBQVcsR0FBbEIsVUFBbUIsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUMvQixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDZCQUFTLEdBQWhCLFVBQWlCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDN0IsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3hDLENBQUM7SUFFRDs7O09BR0c7SUFDSSw0QkFBUSxHQUFmLFVBQWdCLElBQWM7UUFBZCxxQkFBQSxFQUFBLFNBQWM7UUFDNUIsTUFBTSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7SUFFRDs7O09BR0c7SUFDSSw2QkFBUyxHQUFoQixVQUFpQixJQUFjO1FBQWQscUJBQUEsRUFBQSxTQUFjO1FBQzdCLE1BQU0sQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN4QyxDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksZ0NBQVksR0FBbkIsVUFBb0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUNoQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDM0MsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDRCQUFRLEdBQWYsVUFBZ0IsSUFBYztRQUFkLHFCQUFBLEVBQUEsU0FBYztRQUM1QixNQUFNLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkMsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQWw1QkQsSUFrNUJDO0FBbDVCWSw4QkFBUyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/php/index.js
// module id = 212
// module chunks = 44